import qs from "qs";
import request from '@/utils/request'

export function statDetailInviteShare(query) {
  return request({
    url: '/?m=Picture&a=helpStatInfo',
    method: 'get',
    params: query
  })
}

/* 详情页拉新活动检测 */
export function getDetailInviteStatus(data) {
  return request({
    url: '/?m=Picture&a=helpCheck',
    method: 'post',
    data: qs.stringify(data)
  })
}


/* 详情页拉新活动检测 */
export function checkDetailShareLink(data) {
  return request({
    url: '/?m=Picture&a=help',
    method: 'post',
    data: qs.stringify(data)
  })
}
